export default "__VITE_ASSET__Q7gg2oMs__"